import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton, BaasicModal } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { toDate } from 'core/utils';
import { isEmpty } from "lodash";
import { TrackingCaseDocumentUploadModal, TrackingCaseDocumentEditModal, NoteEditModal } from "application/tracking-case/components";
import { isSome } from "core/utils";

function TrackingCasePreviewTemplate({ trackingCasePreviewViewStore, rootStore, t }) {
    const {
        item,
        notes,
        loaderStore,
        openEditDocumentPopup,
        openUploadDocumentPopup,
        openEditNotePopup,
        openDocumentsPage,
        openTrackingCaseEdit,
        uploadDocumentModal,
        editDocumentModal,
        editNoteModal,
        duplicate,
        deleteNote,
        onDocumentView,
        onFieldValues,
        onSubmit,
        onPreview,
        onDownload,
        onDelete
    } = trackingCasePreviewViewStore;

    function mapProducts(item) {
        return item.trackingCaseProducts &&
        item.trackingCaseProducts.map(i=>i.product.itemId).join(", ");
    }

    function mapRequirements(item) {
        if(!isEmpty(item.trackingCaseRequirements)){
            var trackingCaseRequirementRows = item.trackingCaseRequirements.map(tcr=> {
                 return (
                    <div className="col col-lrg-12 u-mar--bottom--sml" key={tcr.id}>
                        <i className={"u-mar--right--med " + (tcr.isCompleted ? "u-icon u-icon--sml u-icon--active" : "u-icon u-icon--sml u-icon--inactive")}></i>
                        {tcr.requirement.name}
                    </div>
                )
            });

            return trackingCaseRequirementRows;
        }

        return <div className="col col-lrg-12">No Requirements</div>;
    }

    function mapTrackingCaseDocuments(item) {
        if(!isEmpty(item.trackingCaseDocuments)){
            var trackingCaseDocumentsRows = item.trackingCaseDocuments.map(tcd => {
                 return (
                    <tr key={tcd.id}>
                        <td>
                            {tcd.name}
                        </td>
                        <td>
                            {tcd.documentType.name}
                        </td>
                        <td>
                            {tcd.isActive ? "Active" : "Deleted"}
                        </td>
                        <td className="table__body--data right">
            <div className="table__icons">
            {isSome(onDocumentView) && tcd.isActive ? (
                    <BaasicButton
                        className="btn btn--icon"
                        label="Document View"
                        onClick={() => onDocumentView(tcd.id)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--preview u-icon--sml"
                    ></BaasicButton>
                ) : null}
            {isSome(onFieldValues) && tcd.isActive ? (
                    <BaasicButton
                        className="btn btn--icon"
                        label="Field Values"
                        onClick={() => onFieldValues(tcd.id)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--edit u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onSubmit) && tcd.isActive && !tcd.mediaVaultId ? (
                    <BaasicButton
                        className="btn btn--icon"
                        label="Submit"
                        onClick={() => onSubmit(tcd)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--upload--grey u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onPreview) && tcd.mediaVaultId ? (
                    <BaasicButton
                        className="btn btn--icon"
                        label="TRACKING_CASE_DOCUMENT.LIST.ACTIONS.OPEN"
                        onClick={() => onPreview(tcd)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--new-tab u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onDownload) && tcd.mediaVaultId ? (
                    <BaasicButton
                        className="btn btn--icon"
                        label="TRACKING_CASE_DOCUMENT.LIST.ACTIONS.DOWNLOAD"
                        onClick={() => onDownload(tcd)}
                        onlyIcon={true}
                        icon = "u-icon u-icon--download u-icon--sml"
                    ></BaasicButton>
                ) : null}
                {isSome(onDelete) && tcd.isActive ? (
                    <BaasicButton
                        className="btn btn--icon is-delete"
                        icon = "u-icon u-icon--delete u-icon--sml"
                        label = "Delete"
                        onlyIcon={true}
                        onClick={() => onDelete(tcd)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
                    </tr>
                )
            });

            return trackingCaseDocumentsRows;
        }

        return <tr><td colSpan="4">No Documents</td></tr>;
    }

    function mapCaseNotes(notes) {
        if(!isEmpty(notes)){
            var caseNoteRows = notes.map(cn=> {
                 return (
                    <div className="row u-mar--top--sml u-separator--preview" key={cn.id}>
                        <div className="col col-lrg-9">
                            <div>{toDate(cn.dateCreated)} - {cn.author && cn.author.fullName}</div>
                            <div className="u-mar--top--xsml">{cn.note}</div>
                        </div>
                        <div className="col col-lrg-3">
                            <div className="table__icons">
                                <BaasicButton
                                    className="btn btn--icon"
                                    icon='u-icon u-icon--edit u-icon--sml'
                                    label="Edit"
                                    onlyIcon={true}
                                    onClick={() => openEditNotePopup(cn.id)}
                                />
                                <BaasicButton
                                    className="btn btn--icon is-delete"
                                    icon="u-icon u-icon--delete u-icon--sml"
                                    label="Delete"
                                    onlyIcon={true}
                                    onClick={() => deleteNote(cn.id)}
                                />
                            </div>
                        </div>
                    </div>
                );
            });

            return caseNoteRows;
        }

        return <div className="col col-lrg-12">No Notes</div>;
    }
 
    return (
        <PreviewLayout store={trackingCasePreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible = {false} loading={loaderStore.loading}>

            <div className="row">
                <div className="col col-sml-12 col-lrg-12">
                    <div className="card card--form card--primary card--med">

                        <React.Fragment>
                            <div className="u-mar--bottom--med">
                                <div className="u-flex--space-between">
                                    <h3>
                                        <strong>{item && <React.Fragment>Tracking Case {item.docCode}</React.Fragment>}</strong>
                                    </h3>
                                        
                                    <div className="u-flex--primary">
                                        <BaasicButton
                                            type='button'
                                            className="btn btn--base btn--primary u-mar--right--tny"
                                            onClick={() => duplicate()}
                                            label={t('Duplicate')}
                                        />
                                        <BaasicButton
                                            type='button'
                                            className="btn btn--base btn--ghost"
                                            onClick={() => rootStore.routerStore.goBack()}
                                            label={t('Back')}
                                        />
                                    </div>

                                </div>
                            </div>
                        </React.Fragment>

                        <div className="row">
                            <div className="col col-sml-12 col-lrg-6 u-mar--bottom--med">
                                <React.Fragment>
                                    <div className="u-flex--space-between">
                                        <h4>General Info</h4>
                                        <BaasicButton
                                            type='button'
                                            className="btn btn--base btn--primary"
                                            onClick={() => openTrackingCaseEdit()}
                                            label={t('Edit')}
                                        />
                                    </div>
                                    <hr></hr>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-6">
                                                <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.PATIENT_LABEL')}</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-6">
                                                {item && item.patient && <React.Fragment>{item.patient.firstName + ' ' + item.patient.lastName}</React.Fragment>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="u-separator--preview">
                                        <div className="row">
                                            <div className="col col-sml-12 col-lrg-6">
                                                <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.FACILITY_LABEL')}</div>
                                            </div>
                                            <div className="col col-sml-12 col-lrg-6">
                                                {item && item.facility && <React.Fragment>{item.facility.name}</React.Fragment>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.ITEM_CATEGORY_LABEL')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item && item.itemCategory && <React.Fragment>{item.itemCategory.name}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.PRODUCTS_LABEL')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item &&<React.Fragment>{mapProducts(item)}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.PREVIEW.PRIMARY_INSURANCE')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item && item.patient && <React.Fragment>{item.patient.primaryInsurance}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.REFERENCE_LABEL')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item &&<React.Fragment>{item.reference}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.VALID_FROM_LABEL')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item && item.validFrom && <React.Fragment>{toDate(item.validFrom)}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.EDIT.VALID_TO_LABEL')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item && item.validTo && <React.Fragment>{toDate(item.validTo)}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        <div className="form__group__label is-preview">{t('TRACKING_CASE.PREVIEW.CASE_STATUS')}</div>
                                                    </div>
                                                    <div className="col col-sml-12 col-lrg-6">
                                                        {item && item.caseStatus && <React.Fragment>{item.caseStatus.name}</React.Fragment>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>

                                <React.Fragment>
                                    <div className="row u-mar--top--med">
                                        <div className="col col-lrg-12">
                                            <h4>Requirements</h4>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <div className="u-separator--preview">
                                                <div className="row">
                                                    {item && <React.Fragment>{mapRequirements(item)}</React.Fragment>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>

                                <React.Fragment>
                                    <div className="row u-mar--top--med">
                                        <div className="col col-lrg-12">
                                            <div className="u-flex--space-between">
                                                <h4>Documents</h4>
                                                <div>
                                                    <BaasicButton
                                                        type='button'
                                                        className="btn btn--base btn--primary u-mar--right--tny"
                                                        onClick={() => openEditDocumentPopup()}
                                                        label={t('Create New')}
                                                    />
                                                    <BaasicButton
                                                        type='button'
                                                        className="btn btn--base btn--primary u-mar--right--tny"
                                                        onClick={() => openUploadDocumentPopup()}
                                                        label={t('Upload')}
                                                    />
                                                    <BaasicButton
                                                        type='button'
                                                        className="btn btn--base btn--primary"
                                                        onClick={() => openDocumentsPage()}
                                                        label={t('Documents Page')}
                                                    />
                                                </div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            <table className="table--preview">
                                                <colgroup>
                                                    <col />
                                                    <col />
                                                    <col />
                                                    <col width="150" />
                                                </colgroup>
                                                <thead >
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Type</th>
                                                        <th>Status</th>
                                                        <th className="type--right">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item && mapTrackingCaseDocuments(item)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </React.Fragment>
                            
                            </div>

                            <div className = "col col-sml-12 col-lrg-6 u-mar--bottom--med">

                                <React.Fragment>
                                    <div className="u-flex--space-between">
                                        <h4>Notes</h4>
                                        <BaasicButton
                                            type='button'
                                            className="btn btn--base btn--primary"
                                            onClick={() => openEditNotePopup()}
                                            label={t('Add')}
                                        />
                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col col-lrg-12">
                                            {item && mapCaseNotes(notes)}
                                        </div>
                                    </div>
                                </React.Fragment>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <BaasicModal className="modal__content modal--med" modalParams={uploadDocumentModal}>
                <TrackingCaseDocumentUploadModal />
            </BaasicModal>

            <BaasicModal className="modal__content modal--med" modalParams={editDocumentModal}>
                <TrackingCaseDocumentEditModal />
            </BaasicModal>

            <BaasicModal className="modal__content modal--sml" modalParams={editNoteModal}>
                <NoteEditModal />
            </BaasicModal>

        </PreviewLayout>
    )
}

TrackingCasePreviewTemplate.propTypes = {
    trackingCasePreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
    rootStore: PropTypes.object
};

export default defaultTemplate(TrackingCasePreviewTemplate);